export default __webpack_public_path__ + "static/Tek_Bow-fe96c8a53a210e232cf6404c00d69a8e.png";